import { Suspense } from 'react';
import { LoadingFallback } from '@/components/common/LoadingFallback';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';

interface LazyRouteProps {
  children: React.ReactNode;
  fallbackMessage?: string;
}

export function LazyRoute({ children, fallbackMessage }: LazyRouteProps) {
  return (
    <ErrorBoundary>
      <Suspense fallback={<LoadingFallback message={fallbackMessage} />}>
        {children}
      </Suspense>
    </ErrorBoundary>
  );
}
